import React from "react";

export function FormInfo({ children }) {
  if (!children) return null;

  return (
    <small className="text-xs leading-none text-slate-500">{children}</small>
  );
}
